export const SHORT = 'short';
export const MEDIUM = 'medium';
export const LONG = 'long';
